import React from "react";
import each from "lodash/each";
import { isEmpty } from "lodash/lang";
import { useSelector } from "react-redux";
import columnCustomizer from "./columnCustomizer";
import HandsonTable from "../../../components/table/handsonTable/handsonTable";

const MAX_ROWS_TO_FILTER = 25000;

export const RawDataTable = ({ startPolling }) => {
  const {
    tableInfo,
    currentUser: {
      showCloseWindowButton,
      showViewAllDataButton,
      showViewAllDataUrl,
      showSharedMembersDataButton,
      showSharedMembersUrl,
      hideSharedMembersDataButton,
      hideSharedMembersUrl,
      showViewSummaryButton,
      showViewSummaryUrl,
      showViewBackButton,
      showViewBackUrl
    },
    headerInfo,
    labelInfo
  } = useSelector((state) => state.rawDataTable);

  const columns = tableInfo.columns || [];
  const { tableConfiguration: { linkColumns = [] } = {} } = tableInfo;
  const customizedColumns = columnCustomizer(tableInfo.colHeaders, columns, linkColumns);
  const hiddenColumns = {
    columns: []
  };
  let colHeaders = tableInfo.colHeaders;
  let isManyColumns = !isEmpty(tableInfo.data) && tableInfo.data.length > 99999 && true;

  each(linkColumns, (colName) => {
    const colIndex = tableInfo.colHeaders.indexOf(colName);
    colHeaders = colHeaders.splice(0);
    colHeaders.splice(colIndex + 1, 0, `${colName} url`);
    customizedColumns.splice(colIndex + 1, 0, `{ type: "text" }`);
    hiddenColumns.columns.push(colIndex + 1);
  });

  return (
    <HandsonTable
      startPolling={startPolling}
      showExportFileButton
      showExportCSV
      data={tableInfo.data}
      colHeaders={colHeaders}
      rowHeaders
      hiddenColumns={hiddenColumns}
      columns={customizedColumns}
      rowHeaderWidth={isManyColumns && 70}
      fragmentSelection
      columnSorting
      filters={tableInfo.data?.length <= MAX_ROWS_TO_FILTER}
      stretchH="all"
      dropdownMenu={
        tableInfo.data?.length > 1 && tableInfo.data?.length <= MAX_ROWS_TO_FILTER
          ? [
              "filter_by_condition", //
              "---------",
              "filter_by_value",
              "filter_action_bar"
            ]
          : false
      }
      colWidths={tableInfo.colWidths}
      showCloseWindowButton={showCloseWindowButton}
      showViewAllDataButton={showViewAllDataButton}
      showViewAllDataUrl={showViewAllDataUrl}
      showSharedMembersDataButton={showSharedMembersDataButton}
      showSharedMembersUrl={showSharedMembersUrl}
      hideSharedMembersDataButton={hideSharedMembersDataButton}
      hideSharedMembersUrl={hideSharedMembersUrl}
      showViewSummaryButton={showViewSummaryButton}
      showViewSummaryUrl={showViewSummaryUrl}
      showViewBackButton={showViewBackButton}
      showViewBackUrl={showViewBackUrl}
      headerInfo={headerInfo}
      labelInfo={labelInfo}
    />
  );
};
